"use client"

import { useTranslations } from "next-intl"

export const SkipToContent = () => {
  const t = useTranslations("nav")
  return (
    <a
      href="#main-content"
      className="focus:bg-brand focus:text-fg-inverted focus:rounded-4x focus:ring-brand focus:z-modal focus:font-display sr-only focus:not-sr-only focus:fixed focus:top-300 focus:left-300 focus:px-400 focus:py-250 focus:font-semibold focus:ring-2 focus:ring-offset-2 focus:outline-none"
    >
      {t("skipToContent")}
    </a>
  )
}
